import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

const CustomModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 6px;
  }

  .ant-modal-header {
    border-radius: 6px;
    border-bottom: none;
    font-weight: bold;

    .ant-modal-title {
      font-weight: bold;
    }
  }

  .ant-modal-body {
    padding-top: 8px;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 16px;
    padding-top: 8px;
  }

  p {
    color: #656668;
  }
`;

function CustomModal(props) {
  const { children, onOk, confirmLoading, closable, maskClosable, cancelButtonProps } = props;

  const [isOnOkRunning, setIsOnOkRunning] = useState(false);
  const isModalLocked = confirmLoading || isOnOkRunning;
  const handleOnOkClick = async () => {
    try {
      const onClickReturn = onOk && onOk();
      if (onClickReturn) {
        setIsOnOkRunning(true);
        await onClickReturn;
      }
    } finally {
      setIsOnOkRunning(false);
    }
  };

  return (
    <CustomModalStyled
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onOk={handleOnOkClick}
      confirmLoading={isModalLocked}
      cancelButtonProps={{ ...cancelButtonProps, disabled: isModalLocked }}
      closable={!isModalLocked && closable}
      maskClosable={!isModalLocked && maskClosable}
    >
      {children}
    </CustomModalStyled>
  );
}

CustomModal.propTypes = {
  children: PropTypes.node.isRequired,
  onOk: PropTypes.func,
  confirmLoading: PropTypes.bool,
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  cancelButtonProps: PropTypes.shape(Button),
};

CustomModal.defaultProps = {
  onOk: undefined,
  confirmLoading: false,
  closable: true,
  maskClosable: true,
  cancelButtonProps: {},
};

export default CustomModal;
